import { constructURL } from 'helpers/url';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  select(event) {
    const { target } = event.detail;
    const value = target.getAttribute('value');
    const url = constructURL(window.location.href, { payroll_period_id: value });
    Turbo.visit(url.toString());
  }
}
